import { computed, observable, toJS } from 'mobx';
import ServiceStore from '../../services/ServiceStore';

export default class AssetLocationModel {
    id = null;
    @observable type = null;
    @observable status = null;
    @observable dmrn = null;
    @observable serviceId = null;
    @observable profileKey = null;
    @observable mimeType = null;
    @observable key = null;
    @observable size = null;
    @observable created = null;
    @observable modified = null;
    @observable accessed = null;
    @observable deleted = null;
    @observable lastUpdated = null;

    auth = null;
    serviceStore = null;

    @observable previewUrlValue = null;

    @computed
    get previewUrl() {
        // TODO HACK THIS IS UNCOOL : )
        if (!this.previewUrlValue) {
            switch (this.type) {
            case 'active':
                this.serviceStore.fetchService(this.serviceId)
                    .then((service) => {
                        if (service) {
                            return service.readOperation(this.dmrn).then((operation) => {
                                this.previewUrlValue = operation.signed_url;
                            });
                        }
                        return null;
                    });
                break;
            default:
                break;
            }
            return null;
        }
        return this.previewUrlValue;
    }

    constructor(
        auth, id, type, status, dmrn, serviceId, profileKey, mimeType, key, size, created,
        modified, accessed, deleted, lastUpdated,
    ) {
        this.auth = auth;
        this.id = id;
        this.type = type;
        this.status = status;
        this.dmrn = dmrn;
        this.serviceId = serviceId;
        this.profileKey = profileKey;
        this.mimeType = mimeType;
        this.key = key;
        this.size = size;
        this.created = created;
        this.modified = modified;
        this.accessed = accessed;
        this.deleted = deleted;
        this.lastUpdated = lastUpdated;

        this.serviceStore = new ServiceStore(this.auth);
    }

    toJS() {
        toJS(this);
    }

    static fromJS(auth, object) {
        return new AssetLocationModel(
            auth, object.id, object.type, object.status, object.dmrn, object.service_id,
            object.profile_key, object.mime_type,
            object.key, object.size, object.created, object.modified, object.accessed, object.deleted,
            object.last_updated,
        );
    }
}
